export function bannerAlert(){
    const headerTransparent = document.querySelector('.nav--transparent');
    const bannerAlerts = document.querySelectorAll('.banner__alert');

    if(headerTransparent && bannerAlerts){
        function stackBannerAlerts(){
            let offset = headerTransparent.offsetHeight;
    
            bannerAlerts.forEach((alert) => {
                alert.style.top = `${offset}px`;
                offset += alert.offsetHeight;
            });
        }
        stackBannerAlerts();
        window.addEventListener('resize', stackBannerAlerts);
    }
}

export default bannerAlert;